import { applyMiddleware, combineReducers, createStore, compose } from "redux";
import thunkMiddleware from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';

// cabinet
import authReducer from "./cabinet/reducers/auth-reducer";
import appReducer from './cabinet/reducers/app-reducer';
import userReducer from './cabinet/reducers/user-reducer';
import contactsReducer from './cabinet/reducers/contacts-reducer';
import shopReducer from './cabinet/reducers/shop-reducer';
import couponsReducer from './cabinet/reducers/coupons-reducer';
import cartReducer from './cabinet/reducers/cart-reducer';
import filtersReducer from './cabinet/reducers/filters-reducer';
import commentsReducer from './cabinet/reducers/comments-reducer';
import aphorismsReducer from './cabinet/reducers/aphorisms-reducer';
import favoritesReducer from './cabinet/reducers/favorites-reducer';
import purchasesReducer from './cabinet/reducers/purchases-reducer';
import paymentDataReducer from './cabinet/reducers/payment-data-reducer';
import collectionReducer from './cabinet/reducers/collection-reducer';
// shop
import techniquesReducer from './shop/reducers/techniques-reducer';
import relatedOffersReducer from './shop/reducers/related-offers-reducer';

let reducers = combineReducers({
  app: appReducer,
  filters: filtersReducer,
  auth: authReducer,
  user: userReducer,
  contacts: contactsReducer,
  shop: shopReducer,
  coupons: couponsReducer,
  cart: cartReducer,
  comments: commentsReducer,
  aphorisms: aphorismsReducer,
  favorites: favoritesReducer,
  purchases: purchasesReducer,
  paymentData: paymentDataReducer,
  collection: collectionReducer,

  techniques: techniquesReducer,
  related: relatedOffersReducer,

  form: formReducer,
});

let store;
if (!window.debug) store = createStore(reducers, applyMiddleware(thunkMiddleware));
else{
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(reducers, composeEnhancers(applyMiddleware(thunkMiddleware)));
}
export default store;